export default class ValidAnswer {
  constructor (isValid, message) {
    this.isValid = isValid
    this.message = message
  }
}
